<div class="container-fluid ac-poppins">
  <div class="row">
    <div class="col-xl-12 rowp dashboard-section">
    <div class="header-section mb-2">
      <h2 class="ac-heading">Settings</h2>
    </div>
  </div>
    <div class="col-xl-12">
      <ul class="nav nav-pills ac-gborder mb-3" id="pills-tab" role="tablist">
        <li class="nav-item" role="presentation">
          <button
            class="nav-link ac-tab-button active"
            id="pills-profile-tab"
            data-bs-toggle="pill"
            data-bs-target="#autopay"
            type="button"
            role="tab"
            aria-controls="autopay"
            [aria-selected]="selectedTab === 'autopay'"
            [class.active]="selectedTab === 'autopay'"
            (click)="changeTab('autopay')"
          >
            AutoPay
          </button>
        </li>
        <li class="nav-item" role="presentation" *ngIf="!isNewPaymentExperienceEnabled && permissions.includes('BI-MPM')">
          <button
            class="nav-link ac-tab-button"
            id="pills-home-tab"
            data-bs-toggle="pill"
            data-bs-target="#paymnet-method"
            type="button"
            role="tab"
            aria-controls="paymnet-method"
            [aria-selected]="selectedTab === 'paymentMethods'"
            [class.active]="selectedTab === 'paymentMethods'"
            (click)="changeTab('paymentMethods')"
          >
            Payment Method
          </button>
        </li>
        <li class="nav-item" role="presentation" *ngIf="isPaperlessBillingEnabled">
          <button
            class="nav-link ac-tab-button"
            id="pills-home-tab"
            data-bs-toggle="pill"
            data-bs-target="#paperless-billing"
            type="button"
            role="tab"
            aria-controls="paperless-billing"
            [aria-selected]="selectedTab === 'paperlessBilling'"
            [class.active]="selectedTab === 'paperlessBilling'"
            (click)="changeTab('paperlessBilling')"
          >
            Paperless Billing
          </button>
        </li>
      </ul>
      <div class="tab-content" id="pills-tabContent">
        <div
          class="tab-pane fade show active"
          id="autopay"
          role="tabpanel"
          aria-labelledby="autopay-tab"
          tabindex="0"
        >
          <app-recurring *ngIf="selectedTab == 'autopay'"></app-recurring>
        </div>

        <div
          class="tab-pane fade show active"
          id="paymnet-method"
          role="tabpanel"
          aria-labelledby="paymnet-method-tab"
          tabindex="1"
        >
          <app-payment-methods
            *ngIf="selectedTab == 'paymentMethods'"
          ></app-payment-methods>
        </div>
        <div
          class="tab-pane fade show active"
          id="paperless-billing"
          role="tabpanel"
          aria-labelledby="paperless-billing-tab"
          tabindex="2"
        >
          <app-paperless-billing
            *ngIf="selectedTab == 'paperlessBilling'"
          ></app-paperless-billing>
        </div>
      </div>
    </div>
  </div>
</div>
<div *ngIf="isNewPaymentExperienceEnabled && selectedTab === 'autopay'">
  <div class="card-body">
    <app-payment-flow></app-payment-flow>
  </div>
</div>